export default "__VITE_ASSET__DrdbytW5__"